function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66118 0.3125C5.18618 0.3125 2.33618 3.0625 2.33618 6.4125C2.33618 9.0875 6.16118 13.5125 7.81118 15.3125C8.03618 15.5625 8.33618 15.6875 8.66118 15.6875C8.98618 15.6875 9.28618 15.5625 9.51118 15.3125C11.1612 13.5375 14.9862 9.0875 14.9862 6.4125C14.9862 3.0375 12.1362 0.3125 8.66118 0.3125ZM8.86118 14.7125C8.73618 14.8375 8.56118 14.8375 8.46118 14.7125C7.23618 13.3875 3.21118 8.8375 3.21118 6.4125C3.21118 3.5125 5.66118 1.1875 8.66118 1.1875C11.6612 1.1875 14.1112 3.5375 14.1112 6.4125C14.1112 8.8375 10.0862 13.3625 8.86118 14.7125Z",
  fill: "#323F4B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66118 3.91253C7.18618 3.91253 5.96118 5.11253 5.96118 6.61253C5.96118 8.08753 7.16118 9.31253 8.66118 9.31253C10.1612 9.31253 11.3612 8.11253 11.3612 6.61253C11.3612 5.11253 10.1362 3.91253 8.66118 3.91253ZM8.66118 8.41253C7.66118 8.41253 6.83618 7.58753 6.83618 6.58753C6.83618 5.58753 7.66118 4.76253 8.66118 4.76253C9.66118 4.76253 10.4862 5.58753 10.4862 6.58753C10.4862 7.58753 9.66118 8.41253 8.66118 8.41253Z",
  fill: "#323F4B"
});
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.5a5a100205678ef9cc46ed93effd429f.svg";
export { ForwardRef as ReactComponent };